import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import ListDataPod from '../../../components/ListDataPod';
import { getEnrollmentData } from '../../../utils/charts';

const messages = defineMessages({
  title: {
    id: 'hubs.student-life.school-size.title',
    defaultMessage: 'School Size',
  },
  graduateStudents: {
    id: 'hubs.student-life.school-size.graduate-students',
    defaultMessage: 'Graduate Students',
  },
  undergradStudents: {
    id: 'hubs.student-life.school-size.undergraduate-students',
    defaultMessage: 'Undergraduate Students',
  },
  totalStudents: {
    id: 'hubs.student-life.school-size.total-students',
    defaultMessage: 'Total Students',
  },
  verySmall: {
    id: 'hubs.student-life.school-size.very-small',
    defaultMessage: 'Very Small',
  },
  small: {
    id: 'hubs.student-life.school-size.small',
    defaultMessage: 'Small',
  },
  medium: {
    id: 'hubs.student-life.school-size.medium',
    defaultMessage: 'Medium',
  },
  large: {
    id: 'hubs.student-life.school-size.large',
    defaultMessage: 'Large',
  },
  veryLarge: {
    id: 'hubs.student-life.school-size.very-large',
    defaultMessage: 'Very Large',
  },
});

const getSchoolSize = totalEnrollment => {
  if (totalEnrollment <= 0) {
    return null;
  } else if (totalEnrollment <= 2000) {
    return messages.verySmall;
  } else if (totalEnrollment <= 7000) {
    return messages.small;
  } else if (totalEnrollment <= 13000) {
    return messages.medium;
  } else if (totalEnrollment <= 20000) {
    return messages.large;
  } else {
    return messages.veryLarge;
  }
};

const SchoolSize = ({ schoolSize, intl }) => {
  const [undergradEnrollment, gradEnrollment, totalEnrollment] = getEnrollmentData(
    schoolSize,
  );

  const centerMessage = getSchoolSize(totalEnrollment);
  const formatter = new Intl.NumberFormat('en-US');

  const list = [];
  if (undergradEnrollment > 0) {
    list.push(
      `${formatter.format(undergradEnrollment)} ${intl.formatMessage(
        messages.undergradStudents,
      )}`,
    );
  }
  if (gradEnrollment > 0) {
    list.push(
      `${formatter.format(gradEnrollment)} ${intl.formatMessage(
        messages.graduateStudents,
      )}`,
    );
  }
  if (totalEnrollment > 0) {
    list.push(
      `${formatter.format(totalEnrollment)} ${intl.formatMessage(
        messages.totalStudents,
      )}`,
    );
  }
  const title = intl.formatMessage(messages.title);

  return totalEnrollment > 0 ? (
    <ListDataPod
      header={title}
      ariaLabel={`${title}, ${intl.formatMessage(centerMessage)}`}
      content={{
        list,
        value: intl.formatMessage(centerMessage),
        boldLastItem: true,
      }}
    />
  ) : null;
};

SchoolSize.propTypes = {
  schoolSize: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(SchoolSize);
